import { Poly } from './poly';
import { createShape } from './util';
export const Polyline = createShape('polyline', {}, { parent: Poly });
//# sourceMappingURL=polyline.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/shape/polyline.js
// module id = null
// module chunks = 